import { PayloadAction } from '@reduxjs/toolkit'
import { FootprintSlice } from 'src/core/models'

const requestState = {
  loading: false,
  footPrint: null,
  success: false,
  error: null
}

const reducers = {
  /* Get FootPrint Types Reducer */
  setFootPrintTypesLoading: (state: FootprintSlice, action: PayloadAction<boolean>) => {
    state.footPrintTypes.loading = action.payload
  },
  setFootPrintTypesResponse: (state: FootprintSlice, action: PayloadAction<any>) => {
    state.footPrintTypes.footPrintTypes = action.payload
  },
  setFootPrintTypesError: (state: FootprintSlice, action: PayloadAction<string>) => {
    state.footPrintTypes.error = action.payload
  },

  /* My Footprint Reducers */
  setFootPrintLoading: (state: FootprintSlice, action: PayloadAction<boolean>) => {
    state.myFootprint.loading = action.payload
  },
  setFootPrintResponse: (state: FootprintSlice, action: PayloadAction<any>) => {
    state.myFootprint.list = action.payload
  },
  setFootPrintError: (state: FootprintSlice, action: PayloadAction<string>) => {
    state.myFootprint.error = action.payload
  },

  /* Create FootPrint Reducers */
  setCreateFootPrintLoading: (state: FootprintSlice, action: PayloadAction<boolean>) => {
    state.createFootPrint.loading = action.payload
  },
  setCreateFootPrintSuccess: (state: FootprintSlice, action: PayloadAction<any>) => {
    state.createFootPrint.success = action.payload
  },
  setCreateFootPrintError: (state: FootprintSlice, action: PayloadAction<string>) => {
    state.createFootPrint.error = action.payload
  },
  addFootPrintToList: (state: FootprintSlice, action: PayloadAction<any>) => {
    state.myFootprint.list = [...state.myFootprint.list, action.payload]
  },
  resetFootPrintCreateState: (state: FootprintSlice) => {
    state.createFootPrint = requestState
  },

  /* Update Foorprint Reducer */
  setUpdateFootPrintLoading: (state: FootprintSlice, action: PayloadAction<boolean>) => {
    state.updateFootPrint.loading = action.payload
  },
  setUpdateFootPrintSuccess: (state: FootprintSlice, action: PayloadAction<any>) => {
    state.updateFootPrint.success = action.payload
  },
  setUpdateFootPrintError: (state: FootprintSlice, action: PayloadAction<string>) => {
    state.updateFootPrint.error = action.payload
  },
  updateFootPrintList: (state: FootprintSlice, action: PayloadAction<any>) => {
    const newList = state.myFootprint.list.map((x: any) => x.id === action.payload.id ? action.payload : x)
    state.myFootprint.list = newList
  },
  resetUpdateFootPrintState: (state) => {
    state.updateFootPrint = requestState
  },

  // Delete FootPrint Reducers
  setDeleteFootPrintSuccess: (state: FootprintSlice, action: PayloadAction<boolean>) => {
    state.deleteFootPrint.success = action.payload
  },
  setDeleteFootPrintLoading: (state: FootprintSlice, action: PayloadAction<boolean>) => {
    state.deleteFootPrint.loading = action.payload
  },
  deleteFootPrintItemFromList: (state: FootprintSlice, action: PayloadAction<number>) => {
    const newList = state.myFootprint.list.filter((x: any) => x.id !== action.payload)
    state.myFootprint.list = newList
  },

  // Footprint VS Compensation Chart
  setFootPrintVsCompensationLoading: (state: FootprintSlice, action: PayloadAction<boolean>) => {
    state.footPrintVsCompensation.loading = action.payload
  },
  setFootPrintVsCompensationData: (state: FootprintSlice, action: PayloadAction<any>) => {
    state.footPrintVsCompensation.data.footprintCo2Sum = action.payload.footprintCo2Sum
    state.footPrintVsCompensation.data.co2PurchaseSum = action.payload.co2PurchaseSum
    state.footPrintVsCompensation.data.data = action.payload.data
  },

  // Footprint VS Compensation Chart
  setFootPrintHistoryLoading: (state: FootprintSlice, action: PayloadAction<boolean>) => {
    state.footPrintHistory.loading = action.payload
  },
  setFootPrintHistoryData: (state: FootprintSlice, action: PayloadAction<any>) => {
    state.footPrintHistory.data = action.payload
  }
}

export { reducers }
